import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

function PrivateRoute({
  component: Component,
  isAuthenticated,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={props => {
        return (isAuthenticated ? <Component {...props} /> : (
          <Redirect to="/admin/login" />
        ))
      }}
    />
  );
}


const mapStateToProps = (state) => ({
  isAuthenticated: !!state.app.user && state.app.user.isActive,
});

export default connect(mapStateToProps)(PrivateRoute);
